import { Grid2 } from "@mui/material";
import React, { useEffect } from "react";
import Custom from "./Custom";
import custom from "../../../Images/Service/customSolution.json";
import application from "../../../Images/Service/application.json";
import cloud from "../../../Images/Service/cloud.json";
import saas from "../../../Images/Service/saas.json";
import aboutUsBg from "../../../Images/aboutUsBg.jpg";
import { useSearchParams } from "react-router-dom";
import { commonCss } from "../../../CssStyle/commonCss";

const Service = () => {
    const [searchParams,setSearchParams]=useSearchParams()
    useEffect(() => {
        const element = document.getElementById(searchParams.get("serviceTitle"));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, [searchParams.get("serviceTitle")]);

    const customSolutionList=["Digital Transformation","Digitalization","Enterprise Solutions","Upgrade","Web & Mobile Solutions","Maintenance"]
    const applicationList=["Custom Web & Mobile Apps","Enterprise Mobility","ECommerce Apps"]
    const cloudList=["Enterprise Cloud Development","Cloud Integration","Cloud Optimization"]
    const saasList=["Custom SaaS","Implementation","SaaS for Startups","Integration","SaaS for Enterprises","Optimization"]
  return (

    <Grid2 container spacing={"2rem"} >
      <Custom
      spacing={{xs:"1rem",md:"3rem"}}
      displayDesc={true}
        direction={"row"}
        lottieImage={custom}
        title={"Custom Solution"}
        subtitle={"Revolutionizing Businesses with Next-Gen Digital Solutions"}
        description={"Grow Fast, Think Smart, and Succeed Better Efficient Solutions with Minimal Risk."}
        listTitle={"Our customized Custom Solutions :"}
        listName={customSolutionList}
        width={"40%"}
        id="custom"
        styleSX={{background:`url(${aboutUsBg})`,backgroundSize: "cover",padding:{xs:"1.5rem",md:"3rem 5rem 2rem 5rem",lg:"3rem 5rem 2rem 5rem"},}}
        mt={{xs:"40%",sm:"30%",md:"15%",lg:"13%",xl:"5%"}}
      />
       <Custom
       spacing={{xs:"1rem",md:"10rem"}}
        direction={"row-reverse"}
        lottieImage={application}
        title={"APPLICATIONS"}
        subtitle={"Visually Impactful Apps That Empower Your Business."}
       
        listName={applicationList}
        width={"100%"}
        id="application"
        mt={0}
        styleSX={{background:`white`,padding:{xs:"5rem 1.5rem 0.5rem 1rem",md:"3rem 5rem 2rem 5rem",lg:"3rem 5rem 2rem 5rem"}}}
      />
      <Custom
      spacing={{xs:"1rem",md:"3rem"}}
      displayDesc={true}
        direction={"row"}
        lottieImage={cloud}
        title={"Cloud Solutions"}
        subtitle={"Cloud Solutions Built to Define Your Business"}
        description={"Enhance Agility and Define Your Business with the Right Cloud Solutions."}
        listTitle={"Our Capabilities in Cloud Services :"}
        listName={cloudList}
        width={"100%"}
        id="cloud"
        styleSX={{background:commonCss.backgroundGray,padding:{xs:"5rem 1.5rem 0.5rem 1rem",md:"3rem 5rem 2rem 3rem",lg:"3rem 5rem 2rem 5rem"}}}
        mt={0}
      />
       <Custom
       spacing={{xs:"1rem",md:"10rem"}}
        direction={"row-reverse"}
        displayDesc={true}
        lottieImage={saas}
        title={"SAAS Solutions"}
        subtitle={"Enhance Business Performance with Tailored SaaS."}
         description={"Unlock Efficiency with Scalable SaaS Solutions for Your Team."}
         listTitle={"Our SaaS Solutions :"}
        listName={saasList}
        width={"40%"}
        id="saas"
        styleSX={{background:`white`,padding:{xs:"5rem 1.5rem 0.5rem 1rem",md:"5rem 5rem 2rem 3rem",lg:"3rem 5rem 2rem 5rem"}}}
        mt={0}
      />
    </Grid2>
    
  );
};

export default Service;
